import types from 'constants/actionTypes';
import { websocketURL } from 'constants/values';

export const connectWebsocket = () => ({
  type: types.WEBSOCKET_CONNECT,
  payload: { websocketURL },
});

export const websocketUpdateCurrentUser = data => ({
  type: types.WEBSOCKET_UPDATE_CURRENT_USER,
  payload: data,
});

export const showCartUpdateMessage = () => ({
  type: types.SHOW_CART_UPDATE_MESSAGE,
});

export const hideCartUpdateMessage = () => ({
  type: types.HIDE_CART_UPDATE_MESSAGE,
});
